import { DatePipe, Location } from '@angular/common';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { environment } from '../../../../../environments/environment';
import { NameValidator } from '../../../validators/name.validator';

import { IPostPromote, PostPromote } from '../../../../../models/postPromote.model';
import Swal from 'sweetalert2';
import { CustomValidators } from '../../../../customValidators';
import { PaginationService } from 'ngx-pagination';
import { ITypeOffer } from '../../../../../models/typeOffer.model';
import { PostPromoteService } from '../../../../../services/postPromote.service';
import { ProductService } from '../../../../../services/product.service';
import { IPost } from '../../../../../models/post.model';
import * as XLSX from "xlsx";
@Component({
  selector: 'app-post-promote',
  templateUrl: './post-promote.component.html',
  styleUrls: ['./post-promote.component.scss']
})
export class PostPromoteComponent implements OnInit {



  @ViewChild('closebutton1') closebutton1;
  search: any;
  allPromotes: PostPromote[] = [];
  allPromotesTmp: PostPromote[] = [];
  // @ts-ignore
  currentPromote: IPromote = [];
  perPage: number = 10;
  totalItems: number = 0;
  //@ts-ignore
  page:number=1;

  sorted = false;
  sorted1 = false;
  sorted01 = false;
  sorted2 = false;
  sorted3 = false;
  sorted4 = false;
  sorted5 = false;
  sorted6 = false;
  isTrueName = false;
  @ViewChild('closebutton') closebutton;
  url_photo: String;
  constructor(private fb: FormBuilder, private postPromoteService: PostPromoteService ,
              private router :Router, private productService : ProductService,
              private datePipe: DatePipe,

              private location: Location,private paginationService: PaginationService) { }

  ngOnInit(): void {
    this.url_photo = environment.url_photo;
    this.loadPromotes();

  }

  goBack(): void {
  this.location.back();
  }

  model = {
    description: ''
  };

  enablePostPromote(prost:PostPromote){
    Swal.fire({
      title: 'Voulez-vous mettre en avant cette annonce ?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonText: 'Non',
      confirmButtonText: 'Oui'
    }).then((result) => {
      if (result.isConfirmed) {
        this.postPromoteService.enablePromote(prost?.id).subscribe(
          rs=> {
            Swal.fire({
              position: 'center',
              icon: 'success',
              title: 'Annonce mise en avant avec succés.',
              showConfirmButton: false,
              timer: 3000
            });
            this.reloadComponent();
          }, error => {
            Swal.fire({
              position: 'center',
              icon: 'error',
              title: error.error.errorMessage,
              showConfirmButton: false,
              timer: 3000
            })
          }
        )
      }
    })
  }

  disablePostPromote(prost:PostPromote){
    Swal.fire({
      title: 'Désactiver cette mise en avant.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonText: 'Non',
      confirmButtonText: 'Oui'
    }).then((result) => {
      if (result.isConfirmed) {
        this.postPromoteService.disablePromote(prost?.id).subscribe(
          rs=> {
            Swal.fire({
              position: 'center',
              icon: 'success',
              title: 'Annonce désactivée avec succés.',
              showConfirmButton: false,
              timer: 1500
            });
            this.reloadComponent();
          }, error => {
            Swal.fire({
              position: 'center',
              icon: 'error',
              title: error.error.errorMessage,
              showConfirmButton: false,
              timer: 3000
            })
        })
      }
    })
  }


  get getPost() { return this.postPromoteForm.controls; }

  postPromoteForm = this.fb.group({
    startDate : new FormControl("" , [Validators.required, CustomValidators.startDateNotBeforeToday]),
    endDate : new FormControl("" , [Validators.required]),
  });

  selectedStartDate : any;
  selectedEndDate : any;
  startDateNotAfterEndDate = false;
  startDateNotBeforeDateNow = false;
  endDateNotAfterStartDate = false;
  startDateNotEqualsEndDate = false;
  getSelectedDate() {
    this.selectedStartDate = this.postPromoteForm.get('startDate')?.value;
    if(this.selectedStartDate > this.selectedEndDate){
      this.startDateNotAfterEndDate = true;
    }
  }

  getSelectedEndDate() {
    const startDateString = this.postPromoteForm.get('startDate')?.value;
    const endDateString = this.postPromoteForm.get('endDate')?.value;

    // Conversion des chaînes en objets Date
    this.selectedStartDate = new Date(startDateString);
    this.selectedEndDate = new Date(endDateString);

    if (this.selectedStartDate > this.selectedEndDate) {
      this.startDateNotAfterEndDate = true;
    } else {
      this.startDateNotAfterEndDate = false;
    }

    if (this.selectedStartDate.getTime() === this.selectedEndDate.getTime()) {
      this.startDateNotEqualsEndDate = true;
    } else {
      this.startDateNotEqualsEndDate = false;
    }

    const oneHourInMilliseconds = 60 * 60 * 1000;

    if (this.selectedEndDate.getTime() - this.selectedStartDate.getTime() < oneHourInMilliseconds) {
      this.endDateNotAfterStartDate = true;
    } else {
      this.endDateNotAfterStartDate = false;
    }
  }



  onViewPromo(promoid: any) {
    this.postPromoteService.getByIdPromote(promoid.id).subscribe(rs=>{
      this.currentPromote = rs;
      // console.log(this.currentPromote);
    })
  }

  isoequalstoname = false;
  verifyPromoteName(){
    return null;
  }


  reloadComponent() {
    let currentUrl = this.router.url;
      this.router.routeReuseStrategy.shouldReuseRoute = () => false;
      this.router.onSameUrlNavigation = 'reload';
      this.router.navigate([currentUrl]);
  }

  updatedPostPromote : IPostPromote;
  onEditPromote(promo: any) {
    this.updatedPostPromote = promo;
    this.postPromoteForm = this.fb.group({
      startDate : new FormControl(this.updatedPostPromote.startDate , [Validators.required, NameValidator.startDateNotBeforeToday]),
      endDate : new FormControl(this.updatedPostPromote.endDate , [Validators.required]),
    });
  }

  loadPromotes() {
    this.postPromoteService.getPostPromote(0,200).subscribe((data: any) => {
      this.allPromotes = data.content;
      this.allPromotesTmp = data.content;
      this.totalItems = data.totalElements;
      this.allPromotes = this.getProductShopName(this.allPromotes)
      // console.log("Liste des mise en avant des vendeurs###...###");
      // console.log(this.allPromotes);
      }, (err) => {
        // console.log('-----> err', err);
    });
  }

  displayPerPage(itemsPerPage: any) {
    this.perPage = itemsPerPage;
    this.loadPromotes();
  }

  getProductShopName(products: any[]): any[] {

    products.forEach(element => {
      if(element?.post?.postSubProducts[0]){
        this.productService.getProductbyProductId(element?.post?.postSubProducts[0]?.subProduct?.productID).subscribe(rs=>{
          element.shopName = rs?.shop?.name;
          element.price = element?.post?.postSubProducts[0]?.finalPrice;
          element.reference = element?.post?.postSubProducts[0]?.subProduct?.subProductID;
        })
      }else if(element?.post?.postServiceModels[0]){
        element.shopName = element?.post?.postServiceModels[0]?.serviceModel?.shop?.name;
        element.price = element?.post?.postServiceModels[0]?.finalPrice;
        element.reference = element?.post?.postServiceModels[0]?.serviceID;
      }
    })
    return products;
  }


  beginDateVal: any = null;
  displayErrorMessage: boolean = false;
  getBeginDate(event: any) {
    this.beginDateVal = event.target.value;
    if(this.beginDateVal != null){
      this.disableEndDate = false;
      if(this.beginDateVal > this.endDateVal){
        this.displayErrorMessage = true;
      }else {
        this.displayErrorMessage = false;
      }
    }
  }
  // Récupération de la date de fin

  endDateVal: any = null;
  disableEndDate: boolean = true;
  getEndDate(event: any) {
    this.endDateVal = event.target.value;
    //console.log(this.endDateVal);
    if(this.beginDateVal > this.endDateVal){
      this.displayErrorMessage = true;
    }else{
      this.displayErrorMessage = false;
    }
  }

  refresh() {
    this.loadPromotes();
    this.dateForm.patchValue({
      beginDate: '',
      endDate: ''
    })
  }


  onPostPromoteFormSubmit(): void {
    let postPromote = new PostPromote();
    const startDate = this.postPromoteForm.controls['startDate'].value;
    const endDate = this.postPromoteForm.controls['endDate'].value;
    // console.log(startDate);
    // console.log(endDate);
    if(!this.startDateNotBeforeDateNow && !this.startDateNotAfterEndDate){
      postPromote.id = this.updatedPostPromote.id;
      postPromote.startDate = startDate;
      postPromote.endDate = endDate;
      // console.log("Updeted post promotion...");
      // console.log(postPromote);
      this.postPromoteService.updatePostPromote(postPromote).subscribe(rs => {
        Swal.fire({
          position: 'top-end',
          icon: 'success',
          title: 'Votre promotion a été modifiée avec succés.',
          showConfirmButton: false,
          timer: 1500
        });
        this.reloadComponent();
      }, error => {
       // console.log(error);
        Swal.fire({
          position: 'top-end',
          icon: 'error',
          title: error.error.errorMessage,
          showConfirmButton: false,
          timer: 4500
        });
      });
    }

  }

  dateForm = this.fb.group({
    beginDate: new FormControl(''),
    endDate: new FormControl('')
  })

  filterByDate() {
    const beginDate = new Date(this.dateForm.get('beginDate').value).toISOString();
    const endDate = new Date(this.dateForm.get('endDate').value).toISOString();
    // console.log("Date sélectionnée")
    // console.log('beginDate:', beginDate);
    // console.log('endDate:', endDate);
    if (!beginDate || !endDate) {
      Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: 'Veuillez renseigner la date de début et la date de fin',
        showConfirmButton: false,
        timer: 3500
      });
      return;
    }else{
      this.postPromoteService.getPostPromoteFilter(beginDate, endDate,this.page - 1, this.perPage).subscribe(data =>{
        this.allPromotes = data.content;
        this.allPromotesTmp = data.content;
        this.totalItems = data.totalElements;
        this.allPromotes = this.getProductShopName(this.allPromotes)
       // console.log("Liste des promotions des vendeurs...###");
        //console.log(data.content);
      });
    }

    // const beginDate1 = new Date(beginDate);
    // const endDate1 = new Date(endDate);
    // this.allPromotes = this.allPromotesTmp.filter((promo) => {
    //   const itemStartDate = new Date(promo.startDate);
    //   const itemEndDate = new Date(promo.endDate);

    //   console.log('itemStartDate:', itemStartDate);
    //   console.log('itemEndDate:', itemEndDate);

    //   const result = (
    //     (beginDate1 <= itemEndDate && endDate1 >= itemStartDate) ||
    //     (!beginDate1 && endDate1 >= itemStartDate) ||
    //     (!endDate1 && beginDate1 <= itemEndDate)
    //   );

    //   console.log('result:', result);

    //   return result;
    // });

    // console.log('Filtered Promotes:', this.allPromotes);
  }



  numberOnly(event: { which: any; keyCode: any; }): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  searchFilter($event: KeyboardEvent) {
    this.allPromotes =  this.allPromotesTmp.filter(
      value => value.postName?.toLowerCase().includes(this.search)
    );
  }

  close() {
    this.closebutton.nativeElement.click();
  }

  close1() {
    this.closebutton1.nativeElement.click();
  }

  deletePromote(id: any) {
    Swal.fire({
      title: 'SUPPRESSION',
      text: 'Voulez vous vraiment supprimer cette mise en avant ?',
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: 'OUI',
      denyButtonText: `NON`,
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        this.postPromoteService.deletePromote(id).subscribe(
          rs => {
          Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: 'La publication a été enlevée dans la des annonces mise en avant avec succès.',
            showConfirmButton: false,
            timer: 1500
          });
          this.loadPromotes();
        },error =>{
          Swal.fire({
            position: 'top-end',
            icon: 'error',
            title: error.error.errorMessage,
            showConfirmButton: false,
            timer: 4500
          });
        });
      } else if (result.isDenied) {
        Swal.fire({
          icon: 'error',
          text: 'Suppression annulée',

        })
      }
    })
  }

  sort1() {
    if (this.sorted1 == false) {
      // Utilisez toLowerCase() pour comparer les chaînes en minuscules
      this.allPromotes.sort((a, b) => a.postName.toLowerCase() > b.postName.toLowerCase() ? 1 : a.postName.toLowerCase() < b.postName.toLowerCase() ? -1 : 0)
      this.sorted1 = true;
    } else {
      // Utilisez toLowerCase() pour comparer les chaînes en minuscules
      this.allPromotes.sort((a, b) => a.postName.toLowerCase() < b.postName.toLowerCase() ? 1 : a.postName.toLowerCase() > b.postName.toLowerCase() ? -1 : 0)
      this.sorted1 = false;
    }
}




  sort3() {
    if(this.sorted3 == false) {
      // @ts-ignore
      this.allPromotes.sort((a, b) => a.shopName.toLowerCase() > b.shopName.toLowerCase() ? 1 : a.shopName.toLowerCase() < b.shopName.toLowerCase() ? -1 : 0)
      this.sorted3 = true;
    } else {
      // @ts-ignore
      this.allPromotes.sort((a, b) => a.shopName.toLowerCase() < b.shopName.toLowerCase() ? 1 : a.shopName.toLowerCase() > b.shopName.toLowerCase() ? -1 : 0)
      this.sorted3 = false;
    }
  }

  sort4() {
    if(this.sorted4 == false) {
      // @ts-ignore
      this.allPromotes.sort((a, b) => a.startDate > b.startDate ? 1 : a.startDate < b.startDate ? -1 : 0)
      this.sorted4 = true;
    } else {
      // @ts-ignore
      this.allPromotes.sort((a, b) => a.startDate < b.startDate ? 1 : a.startDate > b.startDate ? -1 : 0)
      this.sorted4 = false;
    }
  }

  sort5() {
    if(this.sorted5 == false) {
      // @ts-ignore
      this.allPromotes.sort((a, b) => a.ifPostIsSubProduct > b.ifPostIsSubProduct ? 1 : a.ifPostIsSubProduct < b.ifPostIsSubProduct ? -1 : 0)
      this.sorted5 = true;
    } else {
      // @ts-ignore
      this.allPromotes.sort((a, b) => a.ifPostIsSubProduct < b.ifPostIsSubProduct ? 1 : a.ifPostIsSubProduct > b.ifPostIsSubProduct ? -1 : 0)
      this.sorted5 = false;
    }
  }


  strUcFirst(valeur : any){return (valeur+'').charAt(0).toUpperCase()+valeur.substr(1);}


  minDate(): string {
    const today = new Date();
    return today.toISOString().slice(0, 16); // Format ISO pour la date et l'heure.
  }

  exportPostToExelFile(filename: string) {
    const data = document.getElementById('tab-promote');
    const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(data);

    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, filename);
  }

}
